<form name="form" #form="ngForm" (submit)="submit()">
	<section [ngClass]="styles.toolbarWrap">
		<vb-ui-toolbar class="padding-left-0" flex="fill" [justify]="'flex-start'">

			<template-menu *ngIf="allowTemplate()" (onTemplateSelected)="selectTemplate($event)" [templatesService]="WebcastTemplatesService" [tooltipMsg]="'Event_Template_SelectMenuTooltip' | translate">
			</template-menu>
		</vb-ui-toolbar>

		<vb-ui-toolbar [hidden]="isSidebar">
			<a vbBtnSecondary uiSref="portal.scheduledEvents.all">
				{{ 'Cancel' | translate }}
			</a>

			<button type="submit" class="margin-left-5" [disabled]="form.invalid" vbBtnPrimary>
				{{
					(webcast.id ? 'Save' :
						webcast.cloneWebcastId ? 'Event_DuplicateWebcast_SaveLabel' : 'Create' ) | translate
				}}
			</button>
		</vb-ui-toolbar>
	</section>

	<!-- Note: - Had to use ngDefaultControl on each child edit-webcast component
		because difficult add ControlValueAccessor. will be done later.
	-->
	<collapsable-section [headerTitle]="'Event_Edit_BasicSettings' | translate" [invalidSection]="basicSettings?.invalid" [startClosed]="isSidebar">
		<edit-webcast-basic-settings name="basicSettings" ngModel ngDefaultControl #basicSettings="ngModel" [(webcast)]="webcast" [categories]="categories" [features]="features" [isSidebar]="isSidebar" [externalErrors]="basicSettingsErrors">
		</edit-webcast-basic-settings>
	</collapsable-section>

	<collapsable-section [headerTitle]="'Event_Edit_VideoSource' | translate" [invalidSection]="videoSettingsModel?.invalid" [startClosed]="isSidebar">
		{{ videoSettingsModel?.errors?.presentationProfileConflict }}
		@if(isSidebar) {
			<edit-webcast-video-settings-sidebar [(webcast)]="webcast" [features]="features" (sourceRestartInitiated)="sourceRestartInitiated.emit($event)" (switchStreamInitiated)="switchStreamInitiated.emit()">
			</edit-webcast-video-settings-sidebar>
		} @else {
			<edit-webcast-video-settings name="videoSettings" ngModel ngDefaultControl #videoSettings="ngModel" [(webcast)]="webcast" [features]="features" [externalErrors]="validationErrors" [startDate]="webcast.startDate" (automatedWebcastValidationChanged)="validationErrors.automatedDateInPast=!$event" (videoSourceChanged)="onVideoSourceChanged()">
			</edit-webcast-video-settings>
		}

	</collapsable-section>

	<collapsable-section [headerTitle]="'Event_Edit_WebcastRecording' | translate" [invalidSection]="recordingSettings?.invalid" *ngIf="showRecordingSettings" [startClosed]="isSidebar">
		<edit-webcast-recording-settings name="recordingSettings" ngModel ngDefaultControl #recordingSettings="ngModel" [(webcast)]="webcast" [features]="features" [isSidebar]="isSidebar">
		</edit-webcast-recording-settings>

	</collapsable-section>

	<collapsable-section #hostsAndPresentersSection [headerTitle]="(
			webcast.videoSource === WebcastVideoSource.WEBRTC_SINGLE_PRESENTER
				? 'Event_Edit_HostsPresenterAndModerators' :
				webcast.videoSource === WebcastVideoSource.PRODUCER
				? 'Event_Edit_HostsPresentersAndModerators' : 'Event_Edit_HostsAndModerators') | translate" [invalidSection]="hostSettings?.invalid" [startClosed]="isSidebar">
		<edit-webcast-hosts-settings name="hostSettings" ngModel ngDefaultControl #hostSettings="ngModel" [(webcast)]="webcast" [features]="features" [isSidebar]="isSidebar" [hidden]="!hostsAndPresentersSection.expanded">
		</edit-webcast-hosts-settings>
	</collapsable-section>
	<collapsable-section #attendeesSection [headerTitle]="'Attendees' | translate" [invalidSection]="attendeeSettings?.invalid" [startClosed]="isSidebar">
		<edit-webcast-attendee-settings name="attendeeSettings" ngModel ngDefaultControl #attendeeSettings="ngModel" [(webcast)]="webcast" [features]="features" [isSidebar]="isSidebar" [hidden]="!attendeesSection.expanded">
		</edit-webcast-attendee-settings>
	</collapsable-section>
	<collapsable-section #producerSettings *ngIf="!isSidebar && webcast.videoSource === 'Producer'" [headerTitle]="'ProducerSettings' | translate" [invalidSection]="producerSettings?.invalid" [startClosed]="isSidebar">
		<edit-webcast-producer-settings name="producerSettings" ngModel ngDefaultControl #producerSettings="ngModel" [(webcast)]="webcast" [isSidebar]="isSidebar" [hidden]="!producerSettings.expanded">
		</edit-webcast-producer-settings>
	</collapsable-section>
	<collapsable-section [headerTitle]="'Event_Edit_Engagements' | translate" [invalidSection]="engagementSettings?.invalid" [startClosed]="isSidebar">
		<edit-webcast-engagement-settings name="engagementSettings" ngModel ngDefaultControl #engagementSettings="ngModel" [(webcast)]="webcast" [features]="features" [isSidebar]="isSidebar">
		</edit-webcast-engagement-settings>
	</collapsable-section>
	<collapsable-section [headerTitle]="'Event_Edit_Branding' | translate" [invalidSection]="brandingSettings?.invalid" *ngIf="!isSidebar">
		<edit-webcast-branding name="brandingSettings" ngModel ngDefaultControl #brandingSettings="ngModel" [(webcast)]="webcast">
		</edit-webcast-branding>
	</collapsable-section>

	<section [ngClass]="styles.toolbarWrap">
		<vb-ui-toolbar class="padding-left-0" flex="fill" [justify]="'flex-start'">
			<button vbBtnPrimary type="button" [disabled]="form.invalid" (click)="onSaveTemplate.emit()">
				{{ 'Templates_SaveAsTemplate' | translate }}
			</button>
		</vb-ui-toolbar>

		<vb-ui-toolbar>
			<button type="button" vbBtnSecondary [hidden]="!isSidebar" (click)="cancel()">
				{{ 'Cancel' | translate }}
			</button>
			<a vbBtnSecondary [hidden]="isSidebar" uiSref="portal.scheduledEvents.all">
				{{ 'Cancel' | translate }}
			</a>
			<button type="submit" class="margin-left-5" [disabled]="form.invalid" vbBtnPrimary>
				{{
					(webcast.id ? 'Save'
						: webcast.cloneWebcastId ? 'Event_DuplicateWebcast_SaveLabel'
						: 'Create') | translate
				}}
			</button>
		</vb-ui-toolbar>
	</section>

</form>
